export const createMenuHTML = (menus) => {
  const container = document.createElement('div');
  container.id = 'menu-mesh';
  container.className = 'menu-mesh-wrapper';
  container.style.height = `${60 + 36 * menus.length}px`;

  const header = document.createElement('div');
  header.className = 'menu-mesh-header';
  header.innerHTML = 'Menu';

  const content = document.createElement('div');
  content.className = 'menu-mesh-content';

  const itemRefArr = [];
  menus.forEach((menu) => {
    const menuItem = document.createElement('div');
    menuItem.className = 'menu-mesh-item';
    menuItem.innerHTML = menu.title;
    itemRefArr.push(menuItem);
    content.appendChild(menuItem);
  });

  container.appendChild(header);
  container.appendChild(content);
  document.body.appendChild(container);
  return { html: container, itemRefArr };
};
